import React, { useState, useEffect } from "react";

import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

import Icon from "@mui/material/Icon";
import { API_URL } from "config/apiUrl";
import FileInput from "./FileInput";

import Moment from "react-moment";

import MDModal from "components/MDModal";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import DataTable from "examples/Tables/DataTable";

import { getReserve, putReserve } from "../../../api/reserves";

import CreateEditReserves from "../CreateEditReserves";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

import { useSelector } from "react-redux";
import { canEditOrder } from "../../../utils/permissions";

export default function ClientReserveTable({ device, user }) {
  const currentOrder = useSelector((state) => state.orders.currentOrder);
  const canEdit = canEditOrder(user, currentOrder);
  const [reserves, setReserves] = useState([]);
  const [reserveRows, setReserveRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState("");

  const reserveColumns = [
    { Header: "Réserve", accessor: "reserve", align: "center", width: "5%" },
    { Header: "Dates", accessor: "date", align: "center", width: "10%" },
    { Header: "Description", accessor: "description", align: "center", width: "15%" },
    { Header: "Image 1", accessor: "pic1", align: "center", width: "20%" },
    { Header: "Image 2", accessor: "pic2", align: "center", width: "20%" },
    { Header: "Image 3", accessor: "pic3", align: "center", width: "20%" },
  ];

  async function fetchReserves() {
    const response = await getReserve(device.device_id, "Client");
    setReserves(response.data);
  }

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  useEffect(() => {
    fetchReserves();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateReserve = async (reserve, reserveId) => {
    await putReserve(reserve, reserveId);
    fetchReserves();
  };

  useEffect(() => {
    setReserveRows(generateRows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reserves, darkMode]);

  function generateRows() {
    const rows = [];
    for (let i = 0; i < reserves.length; i++) {
      rows.push({
        reserve: (
          <MDTypography component="a" variant="button" fontWeight="medium">
            {i + 1}
          </MDTypography>
        ),
        date: (
          <MDTypography component="a" variant="button" fontWeight="medium">
            <>
              {reserves[i].reserve_date ? (
                <MDBox display="flex" alignItems="center" lineHeight={1}>
                  <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                    <MDTypography variant="caption">Signalée le</MDTypography>
                    <MDTypography display="block" variant="string" fontWeight="medium">
                      <Moment format="DD/MM/YYYY">{reserves[i].reserve_date}</Moment>
                    </MDTypography>
                  </MDBox>
                </MDBox>
              ) : (
                <MDBox display="flex" alignItems="center" lineHeight={1}>
                  <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                    <MDTypography
                      display="block"
                      color="error"
                      variant="caption"
                      fontWeight="medium"
                    >
                      Date non spécifiée
                    </MDTypography>
                  </MDBox>
                </MDBox>
              )}
              {reserves[i].removal_date ? (
                <MDBox display="flex" alignItems="center" lineHeight={1}>
                  <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                    <MDTypography variant="caption">Corrigée le</MDTypography>
                    <MDTypography display="block" variant="string" fontWeight="medium">
                      <Moment format="DD/MM/YYYY">{reserves[i].removal_date}</Moment>
                    </MDTypography>
                  </MDBox>
                </MDBox>
              ) : (
                <MDBox display="flex" alignItems="center" lineHeight={1}>
                  <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                    <MDTypography
                      display="block"
                      variant="caption"
                      color="warning"
                      fontWeight="medium"
                    >
                      Non corrigée
                    </MDTypography>
                  </MDBox>
                </MDBox>
              )}
            </>
          </MDTypography>
        ),
        description: (
          <MDTypography
            component="a"
            sx={(theme) => ({
              display: "block",
              whiteSpace: "normal",
              overflowWrap: "break-word",
              maxWidth: "400px",
            })}
            variant="button"
            fontWeight="medium"
          >
            {reserves[i].reserve_description}
          </MDTypography>
        ),
        pic1: (
          <>
            {reserves[i].filename1 ? (
              <MDBox display="flex" alignItems="center" sx={{ position: "relative" }}>
                <img
                  style={{ borderRadius: "10px", maxWidth: "220px" }}
                  src={`${API_URL}upload/${reserves[i].filename1}?api_key=${
                    process.env.REACT_APP_NGT_API_KEY
                  }&session_token=${localStorage.getItem("sessionToken")}`}
                  alt={`${reserves[i].filename1}`}
                />
                {canEdit &&
                  !reserves[i].filename2 && (
                    <Icon
                      fontSize="medium"
                      onClick={() => {
                        fetch(`${API_URL}files/${reserves[i].filename1}`, {
                          method: "DELETE",
                          headers: {
                            "X-API-KEY": process.env.REACT_APP_NGT_API_KEY,
                            Authorization: "Bearer " + localStorage.getItem("sessionToken"),
                          },
                        });
                        const reserve = {
                          filename1: null,
                        };
                        updateReserve(reserve, reserves[i].reserve_id);
                      }}
                      sx={{
                        position: "absolute",
                        cursor: "pointer",
                        color: "#fff",
                        top: 4,
                        right: 4,
                      }}
                    >
                      delete
                    </Icon>
                  )}
                <Icon
                  fontSize="medium"
                  onClick={() => {
                    setCurrentPhoto(`${API_URL}upload/${reserves[i].filename1}`);
                    setOpen(true);
                  }}
                  sx={{
                    position: "absolute",
                    cursor: "pointer",
                    color: "#fff",
                    top: 4,
                    right:
                      reserves[i].filename2 ||
                      !canEdit
                        ? 4
                        : 28,
                  }}
                >
                  zoom_in
                </Icon>
              </MDBox>
            ) : canEdit ? (
              <FileInput
                device={device}
                reserve={reserves[i]}
                setReserves={setReserves}
                type="Client"
                pictureNumber="1"
              />
            ) : (
              <MDBox display="flex" alignItems="center" lineHeight={1}>
                <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                  <MDTypography
                    display="block"
                    variant="caption"
                    color="warning"
                    fontWeight="medium"
                  >
                    Aucune image
                  </MDTypography>
                </MDBox>
              </MDBox>
            )}
          </>
        ),
        pic2: (
          <>
            {reserves[i].filename2 ? (
              <MDBox display="flex" alignItems="center" sx={{ position: "relative" }}>
                <img
                  style={{ borderRadius: "10px", maxWidth: "220px" }}
                  src={`${API_URL}upload/${reserves[i].filename2}?api_key=${
                    process.env.REACT_APP_NGT_API_KEY
                  }&session_token=${localStorage.getItem("sessionToken")}`}
                  alt={`${reserves[i].filename2}`}
                />
                {canEdit &&
                  !reserves[i].filename3 && (
                    <Icon
                      fontSize="medium"
                      onClick={() => {
                        fetch(`${API_URL}files/${reserves[i].filename2}`, {
                          method: "DELETE",
                          headers: {
                            "X-API-KEY": process.env.REACT_APP_NGT_API_KEY,
                            Authorization: "Bearer " + localStorage.getItem("sessionToken"),
                          },
                        });
                        const reserve = {
                          filename2: null,
                        };
                        updateReserve(reserve, reserves[i].reserve_id);
                      }}
                      sx={{
                        position: "absolute",
                        cursor: "pointer",
                        color: "#fff",
                        top: 4,
                        right: 4,
                      }}
                    >
                      delete
                    </Icon>
                  )}
                <Icon
                  fontSize="medium"
                  onClick={() => {
                    setCurrentPhoto(`${API_URL}upload/${reserves[i].filename2}`);
                    setOpen(true);
                  }}
                  sx={{
                    position: "absolute",
                    cursor: "pointer",
                    color: "#fff",
                    top: 4,
                    right:
                      reserves[i].filename3 ||
                      !canEdit
                        ? 4
                        : 28,
                  }}
                >
                  zoom_in
                </Icon>
              </MDBox>
            ) : (
              <>
                {canEdit && reserves[i].filename1 ? (
                  <FileInput
                    device={device}
                    reserve={reserves[i]}
                    setReserves={setReserves}
                    type="Client"
                    pictureNumber="2"
                  />
                ) : (
                  <MDBox display="flex" alignItems="center" lineHeight={1}>
                    <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                      <MDTypography
                        display="block"
                        variant="caption"
                        color="warning"
                        fontWeight="medium"
                      >
                        Aucune image
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                )}
              </>
            )}
          </>
        ),
        pic3: (
          <>
            {reserves[i].filename3 ? (
              <MDBox display="flex" alignItems="center" sx={{ position: "relative" }}>
                <img
                  style={{ borderRadius: "10px", maxWidth: "220px" }}
                  src={`${API_URL}upload/${reserves[i].filename3}?api_key=${
                    process.env.REACT_APP_NGT_API_KEY
                  }&session_token=${localStorage.getItem("sessionToken")}`}
                  alt={`${reserves[i].filename3}`}
                />
                {canEdit && (
                    <Icon
                      fontSize="medium"
                      onClick={() => {
                        fetch(`${API_URL}files/${reserves[i].filename3}`, {
                          method: "DELETE",
                          headers: {
                            "X-API-KEY": process.env.REACT_APP_NGT_API_KEY,
                            Authorization: "Bearer " + localStorage.getItem("sessionToken"),
                          },
                        });
                        const reserve = {
                          filename3: null,
                        };
                        updateReserve(reserve, reserves[i].reserve_id);
                      }}
                      sx={{
                        position: "absolute",
                        cursor: "pointer",
                        color: "#fff",
                        top: 4,
                        right: 4,
                      }}
                    >
                      delete
                    </Icon>
                  )}
                <Icon
                  fontSize="medium"
                  onClick={() => {
                    setCurrentPhoto(`${API_URL}upload/${reserves[i].filename3}`);
                    setOpen(true);
                  }}
                  sx={{
                    position: "absolute",
                    cursor: "pointer",
                    color: "#fff",
                    top: 4,
                    right: !canEdit ? 4 : 28,
                  }}
                >
                  zoom_in
                </Icon>
              </MDBox>
            ) : (
              <>
                {canEdit && reserves[i].filename1 && reserves[i].filename2 ? (
                  <FileInput
                    device={device}
                    reserve={reserves[i]}
                    setReserves={setReserves}
                    type="Client"
                    pictureNumber="3"
                  />
                ) : (
                  <MDBox display="flex" alignItems="center" lineHeight={1}>
                    <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                      <MDTypography
                        display="block"
                        variant="caption"
                        color="warning"
                        fontWeight="medium"
                      >
                        Aucune image
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                )}
              </>
            )}
          </>
        ),
      });
    }
    return rows;
  }

  return (
    <Grid item xs={12} height="100%">
      <Card sx={{ height: "100%" }}>
        <MDBox
          mx={2}
          mt={-3}
          py={1.5}
          px={2}
          variant="gradient"
          borderRadius="lg"
          sx={{
            background: !darkMode ? "linear-gradient(195deg, #364c70, #273956)" : "white",
            boxShadow: darkMode ? "0 1px 4px 1px white" : "0 1px 4px 1px #344767",
            display: "flex",
            verticalAlign: "middle",
          }}
        >
          <MDTypography
            variant="h5"
            style={{
              width: "50%",
              lineHeight: "2.4rem",
              display: "tableCell",
              verticalAlign: "middle",
            }}
            color={darkMode ? "inherit" : "white"}
          >
            Réserves client
          </MDTypography>
          {canEdit && (
              <Grid style={{ textAlign: "right", width: "50%" }}>
                <CreateEditReserves
                  edit={false}
                  type="Client"
                  device={device}
                  reserves={reserves}
                  setReserves={setReserves}
                />
                {reserves.length > 0 && (
                  <CreateEditReserves
                    edit
                    type="Client"
                    device={device}
                    reserves={reserves}
                    setReserves={setReserves}
                  />
                )}
              </Grid>
            )}
        </MDBox>

        {reserveRows && reserveRows.length === 0 ? (
          <MDBox
            pt={0.75}
            sx={{ textAlign: "center", paddingTop: 3, paddingBottom: 2, height: "100%" }}
          >
            <MDTypography
              component="a"
              variant="h5"
              color={darkMode ? "white" : "inherit"}
              style={{
                display: "tableCell",
                verticalAlign: "middle",
              }}
            >
              Aucune réserve n'a encore été donnée par le client
            </MDTypography>
          </MDBox>
        ) : (
          <MDBox
            pt={0.75}
            sx={{
              height: "100%",
              "div.MuiTableContainer-root": {
                height: "100%",
                display: "flex",
              },
            }}
          >
            <DataTable
              size="medium"
              table={{ columns: reserveColumns, rows: reserveRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
            />
          </MDBox>
        )}
        <MDModal open={open} onClose={() => setOpen(false)} key={currentPhoto}>
          <MDBox
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "transparent",
              boxShadow: "none",
              maxWidth: "90%",
              maxHeight: "90%",
            }}
          >
            <MDBox
              sx={{
                position: "relative",
              }}
            >
              <img
                src={`${currentPhoto}?api_key=${
                  process.env.REACT_APP_NGT_API_KEY
                }&session_token=${localStorage.getItem("sessionToken")}`}
                alt="Zoomed"
                style={{ maxWidth: "90%", maxHeight: "750px", height: "90%" }}
              />
              <Icon
                fontSize="medium"
                onClick={() => setOpen(false)}
                sx={{
                  position: "absolute",
                  cursor: "pointer",
                  color: "#fff",
                  top: "1%",
                  right: "10.5%",
                }}
              >
                close
              </Icon>
            </MDBox>
          </MDBox>
        </MDModal>
      </Card>
    </Grid>
  );
}
